var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_878_17648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.29594 15.4877L4.5721 15.4105C4.83772 15.3363 4.99287 15.0608 4.91865 14.7951L1.76133 3.49629C1.71678 3.33684 1.6107 3.20161 1.46645 3.12037C1.32219 3.03912 1.15157 3.01851 0.992115 3.06308L0.956451 3.07303C0.624389 3.16581 0.43041 3.51021 0.523184 3.84227L3.68058 15.1411C3.7548 15.4067 4.03031 15.5619 4.29594 15.4877Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4152 7.59173C14.414 7.09248 13.4877 6.45524 12.6635 5.69863C12.5942 5.63521 12.5671 5.53786 12.5937 5.44777C13.002 3.90282 13.3053 2.33199 13.5014 0.746051C13.5325 0.482258 13.3902 0.404672 13.2402 0.585706C10.2971 4.10553 5.20486 -0.058259 2.17383 3.14088C2.21022 3.20901 2.23885 3.28101 2.25917 3.35553L4.30745 10.69C7.34366 7.52966 12.4178 11.6676 15.3557 8.15553C15.5057 7.97449 15.5342 7.64346 15.4152 7.59173Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_17648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "currentColor",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.eaf3e3c1e454641627141a1a76aa23b1.svg";
export { ForwardRef as ReactComponent };